if (!customElements.get('brand-story-showcase')) {
  customElements.define(
    'brand-story-showcase',
    class BrandStoryShowcase extends HTMLElement {
      connectedCallback() {
        this.setupReveal();
      }

      disconnectedCallback() {
        this.revealObserver?.disconnect();
      }

      setupReveal() {
        if (this.dataset.revealBound === 'true') {
          return;
        }

        this.dataset.revealBound = 'true';
        this.classList.add('is-reveal-ready');

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }

        this.revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.classList.add('is-visible');
                this.revealObserver?.disconnect();
              }
            });
          },
          { rootMargin: '0px 0px -12% 0px', threshold: 0.16 }
        );
        this.revealObserver.observe(this);

        requestAnimationFrame(() => {
          const rect = this.getBoundingClientRect();
          if (rect.top < window.innerHeight * 0.88 && rect.bottom > 0) {
            this.classList.add('is-visible');
            this.revealObserver?.disconnect();
          }
        });
      }
    }
  );
}
